import React, { useState, useCallback, useRef, useContext } from "react";
import { ServiceContext } from "../../../contexts/ServiceContext";

function ConfirmPhoneNumber({ isOpenConfirm, setIsOpenConfirm, phoneNumber, onConfirmed }) { 
  const [isOpenVerification, setIsOpenVerification] = useState(false);
  const [isOpenThank , setIsOpenThank] = useState(false);
  const {infrastructureService} = useContext(ServiceContext);
  const verificationCodeRef = useRef("");
  const [canResend, setCanResend] = useState(false);
  
  function handleCode(code) {
  verificationCodeRef.current = code;
}

  const VerificationCode = React.memo(function VerificationCode({ onChange }) {
    const [values, setValues] = useState(["", "", "", "", "", ""]);
    const inputsRef = useRef([]);

    const setRef = useCallback((el, i) => {
      inputsRef.current[i] = el;
    }, []);

    const handleChange = (value, index) => {
      if (!/^\d*$/.test(value)) return;

      const newValues = [...values];
      newValues[index] = value;
      setValues(newValues);

      onChange && onChange(newValues.join(""));

      if (value && index < 5) {
        inputsRef.current[index + 1]?.focus();
      }
    };

    return (
      <div style={{ display: "flex", gap: "10px" }}>
        {values.map((v, i) => (
          <input key={i} ref={(el) => setRef(el, i)} type="text" maxLength={1}
          value={v} onChange={(e) => handleChange(e.target.value, i)}
          style={{width: "40px",height: "50px",fontSize: "24px",textAlign: "center",}}/>
        ))}
      </div>
    );
  });

   async function sendConfirmationCodeClick() {
      try {
        await infrastructureService.get("PhoneNumberConfirmation");
         setIsOpenConfirm(false); 
         setIsOpenVerification(true);
         setCanResend(false); 

         const timer = setTimeout(() => {
            setCanResend(true); 
        }, 60000); 
   
        return () => clearTimeout(timer);

      } catch (error) {
         console.error("Confirmation error");
      } 
    } 

    async function confirmUserPhoneNumberClick() {
      try {
         await infrastructureService.post("PhoneNumberConfirmation", {code: verificationCodeRef.current});
         setIsOpenVerification(false); 
         setIsOpenThank(true);
      } catch (error) {
         console.error("Confirmation error");
      } 
    } 

  return (
    <div>
      {isOpenConfirm && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor:"white",borderRadius:"8px",width:"auto",maxWidth:"550px",boxShadow:"0 5px 15px rgba(0,0,0,0.3)",textAlign:"start"}}>
              <div style={{background:"rgb(236, 236, 236)", padding:"10px"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>Before we turn on automatic SMS alerts or phone calls, we need to send a verification code to {phoneNumber} and make sure you received it.</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <p style={{ marginBottom: "20px" }}>
                  I agree to receive SMS notifications and phone calls from Sentry Technologies at the phone number provided above if I enable SMS alerts or phone calls in the website's online dashboard.<br/><br/>
                  I understand that I can use the same online dashboard to define what events will trigger an SMS notification and that message frequency varies depending on events frequency.<br/><br/>
                  Message and data rates may apply. Reply to any SMS message with HELP to receive assistance or STOP to opt out completely.<br/><br/>
                  View our privacy policy at <a className="a-privacy-policy" target="_blank" href="/privacy-policy">dashboard.sentryti.com/privacy-policy</a>.
                </p>
                <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                  <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpenConfirm(false)}>Cancel</div>
                  <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} 
                       onClick={sendConfirmationCodeClick}>Agree</div>
                </div>
              </div>
            </div>
         </div>
      )}

      {isOpenVerification && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor:"white",borderRadius:"8px",width:"auto",maxWidth:"550px",boxShadow:"0 5px 15px rgba(0,0,0,0.3)"}}>
              <div style={{background:"rgb(236, 236, 236)", padding:"10px"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>Please enter the 6-digit verification code we sent to {phoneNumber}</h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px"}}>
                <div style={{ marginBottom: "20px",display:"flex",justifyContent:"center",alignItems:"center"}}>
                  <VerificationCode onChange={handleCode}/>
                </div>
                {canResend && (<div className="a-privacy-policy" style={{cursor:"pointer"}} onClick={sendConfirmationCodeClick}>
                    Send the code again
                </div>)}
                <div className="submit-container" style={{padding:"0px 10px", margin: "20px 0px"}}>
                  <div className="cancel" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} onClick={() => setIsOpenVerification(false)}>Cancel</div>
                  <div className="submit" style={{ height: "30px",borderRadius:"8px",fontSize:"16px" }} 
                       onClick={confirmUserPhoneNumberClick}>Confirm</div>
                </div>
              </div>
            </div>
         </div>
      )}

      {isOpenThank  && (
          <div style={{position: "fixed",top: 0,left: 0,right: 0,bottom: 0,display: "flex",justifyContent: "center",alignItems: "center",zIndex: 1000,}}> 
            <div style={{backgroundColor:"white",borderRadius:"8px",width:"auto",maxWidth:"550px",boxShadow:"0 5px 15px rgba(0,0,0,0.3)"}}>
              <div style={{background:"rgb(236, 236, 236)", padding:"10px"}}>
                <h2 style={{ margin:"0px",padding:"13px 0px" }}>
                  Success!
                  </h2>
              </div>
              <div style={{border: "solid rgb(236, 236, 236) 1px", padding:"10px", textAlign: "start"}}>
                <p>Thank you for verifying your phone number at {phoneNumber}.<br/><br/> You can now use our online dashboard to configure automated SMS alerts and phone calls.</p>
                <div className="submit-container" style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"10px"}}>
                  <div style={{height:"30px",borderRadius:"8px",fontSize:"16px",width:"100px",textAlign:"center",display:"flex",justifyContent:"center",alignItems:"center"}}
                       onClick={() => {setIsOpenThank(false);onConfirmed?.(); }} className="submit">Ok</div>
                </div>
              </div>
            </div>
         </div>
      )}
    </div>
  );
}

export default ConfirmPhoneNumber;
